var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0230713 2.62524C0.816379 1.92494 1.85851 1.5 2.99989 1.5H16.4999C17.6413 1.5 18.6834 1.92494 19.4767 2.62524C19.2923 1.14526 18.0298 0 16.4999 0H2.99989C1.46995 0 0.207504 1.14525 0.0230713 2.62524Z",
    fill: "#0F172A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0230714 5.62524C0.816379 4.92494 1.85851 4.5 2.99989 4.5H16.4999C17.6413 4.5 18.6834 4.92494 19.4767 5.62524C19.2923 4.14526 18.0298 3 16.4999 3H2.99989C1.46995 3 0.207504 4.14525 0.0230714 5.62524Z",
    fill: "#0F172A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6C1.34315 6 0 7.34315 0 9V15C0 16.6569 1.34315 18 3 18H16.5C18.1569 18 19.5 16.6569 19.5 15V9C19.5 7.34315 18.1569 6 16.5 6H12.75C12.3358 6 12 6.33579 12 6.75C12 7.99264 10.9926 9 9.75 9C8.50736 9 7.5 7.99264 7.5 6.75C7.5 6.33579 7.16421 6 6.75 6H3Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.5ee9c59e6d836a10501a2707a595a148.svg";
export { ForwardRef as ReactComponent };